import { useRef, useMemo, useState } from "react";
import { CheckCircleFilled, CloseCircleFilled } from "@ant-design/icons";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise"; // Import Ag-Grid Enterprise features
import "ag-grid-enterprise/styles/ag-grid.css";
import "ag-grid-enterprise/styles/ag-theme-alpine.css";
import axios from "axios";
import {
  ServerSideRowModelModule,
  RowGroupingModule,
} from "ag-grid-enterprise";
import "./InvoiceFollowup.scss";
import { Button, Tag } from "antd";

export default function InvoiceFollowup() {
  const gridRef = useRef();
  const [grandTotalRow, setGrandTotalRow] = useState(null);
  const [pivotMode, setPivotMode] = useState(false);
  const [rowData, setRowData] = useState([]);

  const columnDefs = [
    {
      headerName: "Email Address",
      field: "Email Address",
      minWidth: 200,
      enableRowGroup: true,
      filter: "agTextColumnFilter",
      cellRenderer: (params) => {
        const toValue = params?.data["Email Address"];

        return (
          <div style={{ width: "100%", height: "100%" }}>
            {Array.isArray(toValue) ? (
              toValue.map((item) =>
                item ? <Tag key={item}>{item}</Tag> : null
              )
            ) : toValue ? (
              <Tag key={toValue}>{toValue}</Tag>
            ) : null}
          </div>
        );
      },
    },
    {
      headerName: "Invoice Received",
      field: "invoiceStatus",
      minWidth: 200,
      enableRowGroup: true,
      filter: "agTextColumnFilter",
      enablePivot: true,

      cellRenderer: (params) => {
        console.log("params group:", params);
        // Check if it's a group row or not
        const nodeData = params.data?.invoiceStatus || params.value;
        return (
          <div style={{ width: "100%", height: "100%" }}>
            {nodeData === "Invoice Received" ? (
              <Tag color="green">Invoice Received</Tag>
            ) : (
              <Tag color="red">Invoice Not Received</Tag>
            )}
          </div>
        );
      },
    },

    // {
    //   headerName: "Sent At",
    //   field: "sentAt",
    //   minWidth: 200,
    //   enableRowGroup: true,
    //   cellRenderer: (params) => {
    //     // Get the sentAt value from the row
    //     const sentAt = params.data?.sentAt;

    //     if (!sentAt) return ''; // Return empty if no sentAt value

    //     // Convert sentAt to a Date object
    //     const sentDate = new Date(sentAt);

    //     // Format sentAt date (DD-MMM-YYYY HH:MM:SS AM/PM)
    //     return sentDate.toLocaleString("en-IN", {
    //       year: "numeric",
    //       month: "short",
    //       day: "2-digit",
    //       hour: "2-digit",
    //       minute: "2-digit",
    //       second: "2-digit",
    //       hour12: true, // Optional: Use AM/PM format
    //     });
    //   },
    // },

    // {
    //   headerName: "Email Type",
    //   field: "emailType",
    //   minWidth: 200,
    //   enableRowGroup: true,
    // },
    {
      headerName: "Hotel Name",
      field: "Hotel Name",
      filter: "agTextColumnFilter",
      minWidth: 200,
      enableRowGroup: true,
    },
    {
      headerName: "Checkin Date",
      field: "Trip Start Date",
      minWidth: 200,
      filter: "agTextColumnFilter",
      enableRowGroup: true,
    },
    {
      headerName: "Checkout Date",
      field: "Trip End Date",
      minWidth: 200,
      filter: "agTextColumnFilter",
      enableRowGroup: true,
    },
    {
      headerName: "Booking/TRF ID",
      field: "Booking_Reference",
      minWidth: 200,
      filter: "agTextColumnFilter",
      enableRowGroup: true,
    },

    {
      headerName: "Campaign Round",
      field: "campaignRound",
      minWidth: 200,
      filter: "agTextColumnFilter",
      enableRowGroup: true,
      enablePivot: true,
    },
    {
      headerName: "Followup State",
      field: "followup_stage",
      filter: "agTextColumnFilter",
      minWidth: 200,
      enableRowGroup: true,
      enablePivot: true,
    },
    // {
    //   headerName: "Guest Name",
    //   field: "metaInfo.guest_name",
    //   minWidth: 200,
    //   enableRowGroup: true,
    // },
    {
      headerName: "Total GST",
      field: "total_gst",
      minWidth: 200,
      enableRowGroup: true,
      enableValue: true,
      filter: "agNumberColumnFilter",

      cellRenderer: (params) => {
        // Check if the row is a group row or a child row
        if (!params.node.group) {
          // Destructure the amounts from the data
          const { HotelCGSTAmount, HotelSGSTAmount } = params.data || {};

          // Calculate the total GST
          const totalGST = (HotelCGSTAmount || 0) + (HotelSGSTAmount || 0);

          // Format the total GST as currency in INR
          return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "INR",
          }).format(totalGST);
        }
      },
    },
    {
      headerName: "Email Processed",
      field: "email_events.processed",
      minWidth: 200,
      filter: "agTextColumnFilter",
      enableRowGroup: true,

      cellRenderer: (params) => {
        // Check if the row is a group row or a child row
        if (!params.node.group) {
          // Check the actual boolean value of email_events.processed
          const emailProcessedExists = params.data?.email_events?.processed;

          return emailProcessedExists === "yes" ? (
            <CheckCircleFilled style={{ color: "green" }} />
          ) : (
            <CloseCircleFilled style={{ color: "red" }} />
          );
        }
      },
    },
    {
      headerName: "Email Delivered",
      field: "email_events.delivered",
      minWidth: 200,
      filter: "agTextColumnFilter",
      enableRowGroup: true,

      cellRenderer: (params) => {
        // Check if the row is a group row or a child row
        if (!params.node.group) {
          // Check the actual boolean value of email_events.delivered
          const emailDeliveredExists = params.data?.email_events?.delivered;

          return emailDeliveredExists === "yes" ? (
            <CheckCircleFilled style={{ color: "green" }} />
          ) : (
            <CloseCircleFilled style={{ color: "red" }} />
          );
        }
      },
    },
    {
      headerName: "Email Clicked",
      field: "email_events.clicked",
      minWidth: 200,
      enableRowGroup: true,
      filter: "agTextColumnFilter",

      cellRenderer: (params) => {
        // Check if the row is a group row or a child row
        if (!params.node.group) {
          // Check the actual boolean value of email_events.clicked
          const emailClickExists = params.data?.email_events?.clicked;

          return emailClickExists === "yes" ? (
            <CheckCircleFilled style={{ color: "green" }} />
          ) : (
            <CloseCircleFilled style={{ color: "red" }} />
          );
        }
      },
    },
    {
      headerName: "Email Open",
      field: "email_events.open",
      minWidth: 200,
      enableRowGroup: true,
      filter: "agTextColumnFilter",
      cellRenderer: (params) => {
        // Check if the row is a group row or a child row
        if (!params.node.group) {
          // Check the actual boolean value of email_events.open
          const emailOpenExists = params.data?.email_events?.open;

          return emailOpenExists === "yes" ? (
            <CheckCircleFilled style={{ color: "green" }} />
          ) : (
            <CloseCircleFilled style={{ color: "red" }} />
          );
        }
      },
    },
    {
      headerName: "Email Bounced",
      field: "email_events.bounce",
      minWidth: 200,
      enableRowGroup: true,
      filter: "agTextColumnFilter",
      cellRenderer: (params) => {
        // Check if the row is a group row or a child row
        if (!params.node.group) {
          // Check the actual boolean value of email_events.bounce
          const emailBounceExists = params.data?.email_events?.bounce;

          return emailBounceExists === "yes" ? (
            <CheckCircleFilled style={{ color: "green" }} />
          ) : (
            <CloseCircleFilled style={{ color: "red" }} />
          );
        }
      },
    
    },

    {
      headerName: "Email Spam",
      field: "email_events.spam",
      filter: "agTextColumnFilter",
      minWidth: 200,
      enableRowGroup: true,

      cellRenderer: (params) => {
        // Check if the row is a group row or a child row
        if (!params.node.group) {
          // Check the actual boolean value of email_events.spam
          const emailSpamExists = params.data?.email_events?.spam;

          return emailSpamExists === "yes" ? (
            <CheckCircleFilled style={{ color: "green" }} />
          ) : (
            <CloseCircleFilled style={{ color: "red" }} />
          );
        }
      },
    },
    {
      headerName:"Skip FollowUp",
      field:"skip_followup",
      filter: "agTextColumnFilter",
      enableRowGroup:true
    },
    {
      headerName:"Skip reason",
      field:"skip_reason",
      filter: "agTextColumnFilter",
      enableRowGroup:true
    }
 
  ];

  const getServerSideDatasource = (data) => {
    return {
      getRows: async (gridParams) => {
        console.log(
          "[Datasource] - rows requested by grid: ",
          gridParams.request
        );

        const requestBody = {
          ...gridParams.request,
          database: "hotel_vendor_master",
          table: "yatra_hotel_booking_with_email",
        };

        console.log("Request body:", requestBody);

        try {
          const response = await fetch(
            "https://stage-apiplatform.finkraftai.com/api/hotelFollowUp/followUp",
            // "http://localhost:7001/api/hotelFollowUp/followUp",

            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(requestBody),
            }
          );

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const data = await response.json();
          console.log("Data fetched:", data);

          if (data && Array.isArray(data.data?.rows)) {
            gridParams.success({
              rowData: data.data.rows,
              rowCount: data.data.lastRow,
              ...(data.data.pivotResultFields &&
                data.data.pivotResultFields.length > 0
                ? { pivotResultFields: data.data.pivotResultFields }
                : {}),
            });

            setGrandTotalRow(
              JSON.parse(JSON.stringify(data.data.grandTotalRow))
            );
            setRowData(data.data.rows);
            // gridParams.success({
            //   rowData: data.data.rows,
            // });
          } else {
            gridParams.fail();
          }
        } catch (error) {
          console.error("Error fetching server-side data:", error);
          gridParams.fail();
        }
      },
    };
  };

  const onGridReady = (params) => {
    const datasource = getServerSideDatasource();
    params.api.setGridOption("serverSideDatasource", datasource);
  };

  const sideBarConfig = useMemo(() => ({
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
    ],
  }));

  function findColumnDefByField(columnDefs, field) {
    let result = null;

    // Function to recursively search for the column definition
    function search(columns) {
      for (const column of columns) {
        if (column.field === field) {
          result = column;
          return; // Stop searching once we find the column
        }
        // Recursively search children
        if (column.children) {
          search(column.children);
        }
      }
    }

    search(columnDefs);
    console.log(result, "result in findColumnDefByField")
    return result;
  }

  const handleShowGSTValue = () => {
    if (!gridRef.current) return;

    const columnApi = gridRef.current.columnApi;
    const gridApi = gridRef.current.api;

    // Apply grouping to "followup_stage"
    gridApi.applyColumnState({
      state: [
        { colId: "followup_stage", rowGroup: true },
        { colId: "total_gst", aggFunc: "sum" },
      ],
      applyOrder: true,
    });

    gridApi.setPivotColumns(["invoiceStatus"]); // Set pivot columns
    // gridApi.setPivotMode(true);

    // Enable row grouping on the grid
    gridApi.setGridOption("groupDisplayType", "groupRows");
    gridApi.setGridOption("pivotMode", true);

    // Refresh the grid
    gridApi.refreshClientSideRowModel("group");
    setPivotMode(true);
  };

  const handleShowGSTValueCampaignVise = () => {
    if (!gridRef.current) return;

    const columnApi = gridRef.current.columnApi;
    const gridApi = gridRef.current.api;

    // Apply grouping to "followup_stage"
    gridApi.applyColumnState({
      state: [
        { colId: "campaignRound", rowGroup: true },
        { colId: "total_gst", aggFunc: "sum" },
      ],
      applyOrder: true,
    });

    gridApi.setPivotColumns(["invoiceStatus"]); // Set pivot columns
    // gridApi.setPivotMode(true);

    // Enable row grouping on the grid
    gridApi.setGridOption("groupDisplayType", "groupRows");
    gridApi.setGridOption("pivotMode", true);

    // Refresh the grid
    gridApi.refreshClientSideRowModel("group");
    setPivotMode(true);
  };

  const cancelPivotMode = () => {
    if (!gridRef.current) return;

    const columnApi = gridRef.current.columnApi;
    const gridApi = gridRef.current.api;

    // Apply grouping to "followup_stage"
    gridApi.applyColumnState({
      state: [
        { colId: "total_gst", aggFunc: false },
        { colId: "followup_stage", rowGroup: false },

        { colId: "campaignRound", rowGroup: false },
      ],
      applyOrder: true,
    });

    gridApi.setPivotColumns([]); // Set pivot columns
    // gridApi.setPivotMode(true);

    // Enable row grouping on the grid
    gridApi.setGridOption("groupDisplayType", null); // Remove row grouping
    gridApi.setGridOption("pivotMode", false); // Ensure pivot mode is off
    gridApi.refreshClientSideRowModel("everything"); // Refresh the grid

    setPivotMode(false);
  };

  return (
    <div className="InvoiceFollowup">
      <Button onClick={pivotMode ? cancelPivotMode : handleShowGSTValue}>
        {!pivotMode ? "Show GST Value Collected" : "Cancel Pivot View"}
      </Button>

      <Button
        onClick={pivotMode ? cancelPivotMode : handleShowGSTValueCampaignVise}
      >
        {!pivotMode
          ? "Show GST Value Collected Campaign Vise"
          : "Cancel Pivot View"}
      </Button>
      <div className="ag-theme-alpine" style={{ height: "95%" }}>
        <AgGridReact
          ref={gridRef}
          columnDefs={columnDefs}
          onGridReady={onGridReady}
          rowModelType="serverSide"
          rowSelection="multiple"
          rowGroupPanelShow="always"
          groupDisplayType="multipleColumns"
          defaultColDef={{
            flex: 1,
            editable: false,
            resizable: true,
            minWidth: 150,
          }}
          animateRows={true}
          paginationPageSize={10}
          cacheBlockSize={20}
          modules={[ServerSideRowModelModule, RowGroupingModule]}
          // sideBar={true}
          sideBar={sideBarConfig}
          pinnedBottomRowData={
            grandTotalRow && Object.keys(grandTotalRow).length > 2
              ? [grandTotalRow]
              : []
          }
          autoGroupColumnDef={{
            headerName: "Group",
            cellRenderer: "agGroupCellRenderer",
            cellRendererParams: {
              innerRenderer: (params) => {
                // Ensure 'params.node.field' is correct for your grouped data
                const groupField = params.node?.field;
                console.log("params:", params);
                // Find the original column definition based on the group field
                const originalColumn = findColumnDefByField(
                  columnDefs,
                  groupField
                );
                console.log(originalColumn, "originalColumn")
                console.log(params.node, "params node")
                const nodeData =
                  params?.value || params.data?.[originalColumn?.field];
                // Render group header content
                return originalColumn?.field === "invoiceStatus" ? (
                  <div style={{ width: "100%", height: "100%" }}>
                    {nodeData === "Invoice Received" ? (
                      <Tag color="green">
                        Invoice Received ({params.data?.count})
                      </Tag>
                    ) : (
                      <Tag color="red">
                        Invoice Not Received ({params.data?.count})
                      </Tag>
                    )}
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      height: "100%",
                      marginBottom:"2px",
                      alignItems: "center",
                      justifyContent: "center", // Corrected from `justifyItems` to `justifyContent`
                    }}
                  >
                    {params?.value || params.data?.[originalColumn?.field]}
                    {`${grandTotalRow &&
                        Object.keys(grandTotalRow).length > 0 &&
                        params.value === undefined
                        ? `Total (${rowData.length})`
                        : params.value === "NA"
                          ? ""
                          : ""
                      }`}

                    {params?.data?.count ? (
                      <div style={{ marginLeft: 4}} >
                        {` (${params?.data.count})`}
                      </div >
                    ) : null}
                  </div>
                );
              },
            },
          }}
        />
      </div>
    </div>
  );
}